export const ACCOUNT_TYPES_CONFIG_KEY = "sys.account.types";
export const BUSINESS_TYPES_CONFIG_KEY = "sys.business.types";

export interface IncomeOption { label: string; value: number; disabled: boolean }
export interface IncomeTypeConfig {
  accountTypes: IncomeOption[];
  businessTypes: IncomeOption[];
}

export const EMPTY_INCOME_TYPES: IncomeTypeConfig = { accountTypes: [], businessTypes: [] };

// 各接口使用不同编码。集中映射，不能把账户编码直接用于提现/转赠接口。
export const INCOME_TYPE_MAPPINGS = [
  { accountType: 1, cashType: 0, transferType: 1, withdrawKey: "amountWithdrawOpen", transferKey: "amountTransferOpen" },
  { accountType: 2, cashType: 4, transferType: 5, withdrawKey: "integralWithdrawOpen", transferKey: "integralTransferOpen" },
  { accountType: 3, transferType: 0 },
  { accountType: 4, cashType: 1, transferType: 2, withdrawKey: "chargingAmountWithdrawOpen", transferKey: "chargingAmountTransferOpen" },
  { accountType: 5, cashType: 2, transferType: 3, withdrawKey: "merchantAmountWithdrawOpen", transferKey: "merchantAmountTransferOpen" },
  { accountType: 7, cashType: 3, transferType: 4, withdrawKey: "channelAmountWithdrawOpen", transferKey: "channelAmountTransferOpen" },
];

function parseOptions(value: unknown, name: string): IncomeOption[] {
  if (!Array.isArray(value)) throw new Error(`${name}必须为 JSON 数组`);
  const seen = new Set<number>();
  return value.map((entry: unknown) => {
    if (typeof entry !== "object" || entry === null || !("value" in entry) || !("label" in entry)
      || typeof entry.value !== "number" || !Number.isInteger(entry.value)
      || seen.has(entry.value) || typeof entry.label !== "string" || !entry.label.trim() || entry.label.trim().length > 30)
      throw new Error(`${name}编码须为整数且不可重复，名称为1至30字`);
    if ("disabled" in entry && typeof entry.disabled !== "boolean")
      throw new Error(`${name}的 disabled 必须为 true 或 false`);
    seen.add(entry.value);
    return { value: entry.value, label: entry.label.trim(), disabled: "disabled" in entry && entry.disabled === true };
  });
}

export function parseIncomeTypeOptions(raw: string | null, type: keyof IncomeTypeConfig): IncomeOption[] {
  if (!raw?.trim()) return [];
  const parsed: unknown = JSON.parse(raw);
  return parseOptions(parsed, type === "accountTypes" ? "资金类型" : "业务类型");
}

export function incomeOptions(config: IncomeTypeConfig, scene: "account" | "cash" | "transfer"): IncomeOption[] {
  if (scene === "account") return config.accountTypes;
  return config.accountTypes.flatMap((item) => {
    const mapping = INCOME_TYPE_MAPPINGS.find((entry) => entry.accountType === item.value);
    const value = scene === "cash" ? mapping?.cashType : mapping?.transferType;
    return value === undefined ? [] : [{ label: item.label, value, disabled: item.disabled }];
  });
}

export function incomeLabel(options: IncomeOption[], value: unknown, fallback?: string | null): string {
  return options.find((item) => String(item.value) === String(value))?.label ?? fallback ?? "-";
}

export function incomeSwitchOptions(config: IncomeTypeConfig, scene: "withdraw" | "transfer"): { label: string; value: string; disabled: boolean }[] {
  return config.accountTypes.flatMap((item) => {
    const mapping = INCOME_TYPE_MAPPINGS.find((entry) => entry.accountType === item.value);
    const value = scene === "withdraw" ? mapping?.withdrawKey : mapping?.transferKey;
    return value === undefined ? [] : [{ label: item.label, value, disabled: item.disabled }];
  });
}
